import React, { useState, useEffect } from "react";
import styled from "styled-components";
import axios from "axios";
import { H3, Eyebrow, brandStyles } from "../Typography";

const Job = styled.div`
  margin-bottom: 80px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const HeadingLink = styled.a`
  color: ${({ theme, $colour }) => theme.colours[$colour]};
  text-decoration: none;
`;

const Link = styled.a`
  ${brandStyles.bigLink};
  display: inline-block;
  background-color: ${({ theme, $colour = "blue" }) => theme.colours[$colour]};
  color: ${({ theme, $colour }) =>
    $colour === "white" ? theme.colours.blue : theme.colours.white};
`;

const token = "assemblyhq";
const apiUrl = `https://boards-api.greenhouse.io/v1/boards/${token}/jobs?content=true`;

const CareersList = ({ colour }) => {
  const [jobs, setJobs] = useState([]);
  useEffect(() => {
    async function fetchJobs() {
      const result = await axios(apiUrl);

      setJobs(result.data.jobs);
    }
    fetchJobs();
  }, []);
  return (
    jobs &&
    jobs.map((job) => (
      <Job key={job.internal_job_id}>
        <Eyebrow colour={colour}>{job.location.name}</Eyebrow>
        <H3>
          <HeadingLink $colour={colour} href={job.absolute_url} target="_blank">
            {job.title}
          </HeadingLink>
        </H3>
        <Link
          $colour={colour}
          href={job.absolute_url}
          title={job.title}
          target="_blank"
        >
          Apply now
        </Link>
      </Job>
    ))
  );
};

export default CareersList;
